import { render, staticRenderFns } from "./addCharge.vue?vue&type=template&id=f5e7c0b8&scoped=true"
import script from "./addCharge.vue?vue&type=script&lang=js"
export * from "./addCharge.vue?vue&type=script&lang=js"
import style0 from "./addCharge.vue?vue&type=style&index=0&id=f5e7c0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e7c0b8",
  null
  
)

export default component.exports